import transformToCamelCase from '@/api/shared/transformers/toCamelCaseTransformer';
import { format as formatDate } from '@/utils/date';

export default function transformPackageDailyStats(data) {
  data.dates = data.dates?.map(ts => formatDate(ts, 'jYYYY/jMM/jDD', 'X'));
  data.stats = Object.values(data.stats).map(series => ({
    name: series.title,
    overall: series.overall,
    data: Object.values(series.daily_data),
  }));
  return transformToCamelCase(data);
}
